export const createThemeSlice = (set) => ({
    // Set the default to "system" (or you can choose "light" if you prefer)
    themeMode: 'system',
    toggleTheme: () => set((state) => ({
        // If the current mode is "system", you can decide a default behavior—here we toggle to "light"
        themeMode: state.themeMode === 'dark' ? 'light' : 'dark',
    })),
    setTheme: (mode) => {
        if (mode !== 'light' && mode !== 'dark' && mode !== 'system') {
            throw new TypeError('Invalid input: themeMode must be "light", "dark", or "system"');
        }
        set({ themeMode: mode });
    },
});
//# sourceMappingURL=themeSlice.js.map